<script>
  import clsx from "clsx";
  import { Router, Route, navigateTo } from "yrv/build/dist";
  import { onMount } from "svelte";
  import { operationStore, query } from "@urql/svelte";
  import { GalleryApi } from "../Api/gallery";
  import { galleryData, galleryUrlData, adData, nanoID } from "../Api/store";
  import UrlPattern from "url-pattern";
  import Gallery from "./Gallery.svelte";
  import Overview from "./Overview.svelte";
  import Advertisement from "../Component/Advertisement.svelte";

  export let itemId;
  export let baseUrl;
  export let sticky;

  const gallery = operationStore(GalleryApi, { galleryId: parseInt(itemId) });

  query(gallery);

  gallery.subscribe((storeObj) => {
    if (storeObj.data) {
      galleryData.set(storeObj.data.gallery);
      redirect();
    }
  });

  onMount(() => {
    if (baseUrl.match(/bild\/\d+/)) {
      baseUrl = baseUrl.replace(/(.*)\/bild\/\d+/, "$1");
    }

    galleryUrlData.set(baseUrl);
  });

  function redirect() {
    const pathname = window.location.pathname;
    const patternWithoutItem = new UrlPattern(`${baseUrl}`);
    const parameterWithoutItem = patternWithoutItem.match(pathname);

    if (parameterWithoutItem != null) {
      navigateTo(patternWithoutItem.stringify(parameterWithoutItem));
      return;
    }

    const patternWithItem = new UrlPattern(`${baseUrl}/bild/:itemId`);
    const parameterWithItem = patternWithItem.match(pathname);

    if (parameterWithItem != null) {
      navigateTo(patternWithItem.stringify(parameterWithItem));
      return;
    }

    navigateTo(`${baseUrl}/bild/${itemId}`);
  }
</script>

{#if $galleryData}
  <h2 class={$galleryData.title ? "mb-2 text-xl font-bold" : "sr-only"} id={`headline-${$nanoID}`}>{$galleryData.title || "Galerie"}</h2>
  {#if $galleryData.description}
    <p class="mb-6">{$galleryData.description}</p>
  {/if}
  <div class={clsx("relative", sticky && "z-0")}>
    <Advertisement />
    <div class={$adData.show ? "pointer-events-none blur" : null}>
      <Router>
        <Route exact path={`${baseUrl}`} component={Overview} />
        <Route exact path={`${baseUrl}/bild/:itemId`} component={Gallery} />
      </Router>
    </div>
  </div>
{:else}
  <p class="text-center">Galerie wird geladen...</p>
{/if}
